// Central place to hide work-in-progress features from production without
// deleting the code. Flip to true once a feature is approved for release.
export const FEATURE_FLAGS = {
  HARD_LIDS_ENABLED: true,
  // Hard Lids pages/products are live, but no pricing has been confirmed
  // yet — every price/CTA spot on those pages shows "Coming Soon · Enquire"
  // instead of a figure until this is flipped on.
  HARD_LIDS_SHOW_PRICING: false,
};
